import { Source, SourceAllowedHTTPMethod } from './Source.interface';

export type SourceTypes = {
  [key in SourceType]: SourceTypeSchema;
};

export type DestinationTypes = {
  [key in DestinationType]: DestinationTypeSchema;
};

export type SourceType =
  | 'AIPRISE'
  | 'AIRCALL'
  | 'ALCHEMY'
  | 'ALIPAY'
  | 'ASANA'
  | 'ASHBY'
  | 'ATTENTIVE'
  | 'ASCEND'
  | 'AZURE_EVENT_GRID'
  | 'BASELINKER'
  | 'COINBASE'
  | 'CURSOR'
  | 'DOCUSIGN'
  | 'PUBLISH_API'
  | 'HTTP'
  | 'WEBHOOK'
  | 'MANAGED'
  | 'HOOKDECK_OUTPOST'
  | 'MCP_EVENTS'
  | 'BRIDGE_XYZ'
  | 'BRIDGE_API'
  | 'EBAY'
  | 'FIREBLOCKS'
  | 'FRONTAPP'
  | 'INCIDENT_IO'
  | 'QUICKBOOKS'
  | 'ATTIO'
  | 'LINE'
  | 'CLICKUP'
  | 'CAL_COM'
  | 'SUMSUB'
  | 'MUX'
  | 'SHIPPO'
  | 'ETSY'
  | 'REDUCTO'
  | 'INTERCOM'
  | 'TWITTER'
  | 'TWILIO'
  | 'STRIPE'
  | 'RECHARGE'
  | 'RECURLY'
  | 'GITHUB'
  | 'SHOPIFY'
  | 'POSTMARK'
  | 'TALLY'
  | 'TYPEFORM'
  | 'XERO'
  | 'SVIX'
  | 'RESEND'
  | 'NOMOD'
  | 'OPENLAYER'
  | 'SOHAR_HEALTH'
  | 'CEREBRUM'
  | 'AIRWEAVE'
  | 'RELAY_MESSENGER'
  | 'NITROSEND'
  | 'JUNCTION'
  | 'AGNTIX'
  | 'MEMOS'
  | 'CUURO'
  | 'NOVU'
  | 'BAYOU_ENERGY'
  | 'CELITECH'
  | 'REQUESTY'
  | 'SPEED'
  | 'CROSSMINT'
  | 'TENSORLAKE'
  | 'NOTIFUSE'
  | 'FORMBRICKS'
  | 'MEETING_BAAS'
  | 'VERSIVE'
  | 'WEBINY'
  | 'VERN'
  | 'EPILOT'
  | 'VOICEFLOW'
  | 'SURGE'
  | 'NEXTPAY'
  | 'LINQ'
  | 'PINE_LABS'
  | 'LIVEBLOCKS'
  | 'PRIVY'
  | 'CLEMTA'
  | 'FLEXPRICE'
  | 'ISNAP'
  | 'GLOBALSTACK'
  | 'GENERAL_TRANSLATION'
  | 'TRUNK'
  | 'DOUBLEWORD'
  | 'OUTHIRE'
  | 'BASIQ'
  | 'BINDBEE'
  | 'REPLICATE'
  | 'ADYEN'
  | 'AKENEO'
  | 'ZOOM'
  | 'OURA'
  | 'ONFLEET'
  | 'GITLAB'
  | 'PROPERTY-FINDER'
  | 'WOOCOMMERCE'
  | 'COMMERCELAYER'
  | 'COMMUNITY'
  | 'HUBSPOT'
  | 'HASURA'
  | 'PREFECT'
  | 'KOBOTOOLBOX'
  | 'FIREBERRY'
  | 'HIGHTOUCH'
  | 'ONELOGIN'
  | 'PARAGON'
  | 'REV_AI'
  | 'STUART'
  | 'SIGFOX'
  | 'NIUM'
  | 'THREE_SIXTY_DIALOG'
  | 'BITRISE'
  | 'DATOCMS'
  | 'ITERABLE'
  | 'ONESPAN'
  | 'PARCELLAB'
  | 'ZUORA'
  | 'AWS_EVENTBRIDGE'
  | 'PROXYCLICK'
  | 'BRAZE'
  | 'JUMPCLOUD'
  | 'OPSGENIE'
  | 'PAXOS'
  | 'RUDDERSTACK'
  | 'TRAY_IO'
  | 'COPPER'
  | 'BELVO'
  | 'PUBNUB'
  | 'AMPLITUDE'
  | 'BRINGG'
  | 'DOORDASH_DRIVE'
  | 'MAKE'
  | 'ORY'
  | 'SOCURE'
  | 'VTEX'
  | 'CURRENTS'
  | 'APIFY'
  | 'BUILDER_IO'
  | 'FOURKITES'
  | 'NEW_RELIC'
  | 'OYSTER'
  | 'PROJECT44'
  | 'SPEECHMATICS'
  | 'WORKATO'
  | 'INVOICE_NINJA'
  | 'FORMIO'
  | 'WORKSPACE_ONE'
  | 'AZURE_DEVOPS'
  | 'FRESHSALES'
  | 'OMNISEND'
  | 'PAPERFORM'
  | 'RAILWAY'
  | 'STRAPI'
  | 'YOUCANBOOKME'
  | 'MAILERSEND'
  | 'MAILGUN'
  | 'MERAKI'
  | 'MICROSOFT_GRAPH'
  | 'MICROSOFT_SHAREPOINT'
  | 'PICQER'
  | 'PERSONA'
  | 'PIPEDRIVE'
  | 'SENDGRID'
  | 'SENDGRID_INBOUND'
  | 'WORKOS'
  | 'SYNCTERA'
  | 'AWS_SNS'
  | 'SCALEWAY_TOPICS_AND_EVENTS'
  | 'STOREKIT'
  | 'SKOVIK'
  | 'PRIVIDIUM'
  | 'DODO_PAYMENTS'
  | 'RECURRENTE'
  | 'MONERIUM'
  | 'SALAD_CLOUD'
  | 'TRACKSTAR'
  | 'RUNA'
  | 'AXILIO'
  | 'SUPERTAB'
  | 'HELCIM'
  | 'TOLT'
  | 'SUPERWALL'
  | 'HIREHIVE'
  | 'JUSTT'
  | 'SCALEKIT'
  | 'PINATA'
  | 'LASO_FINANCE'
  | 'CHARGEBLAST'
  | 'PIPECAT_CLOUD'
  | 'PGANALYZE'
  | 'DOTS'
  | 'CAMEL_AI'
  | 'SALSA'
  | 'BLINDPAY'
  | 'GOODY'
  | 'SPACEBRING'
  | 'HEXCLAVE'
  | 'SAJN'
  | 'ORIGAMI'
  | 'SWIPELUX'
  | 'TRAVTUS'
  | 'OMNARA'
  | 'LAYERSWAP'
  | 'VELT'
  | 'ARGIL'
  | 'TERMINAL_TELEMATICS'
  | 'THREE_D_EYE'
  | 'ENODE'
  | 'FANVUE'
  | 'FAUNDIT'
  | 'FAVRO'
  | 'EIGHT_X_EIGHT'
  | 'AXIOM'
  | 'CLOUDENTITY'
  | 'GRIST'
  | 'METABASE'
  | 'PROCORE'
  | 'ROLLER'
  | 'TORII'
  | 'ACUMATICA'
  | 'BASEROW'
  | 'DYNATRACE'
  | 'HALO_PSA'
  | 'LESSONLY'
  | 'PAX8'
  | 'BITDEFENDER'
  | 'CYBERIMPACT'
  | 'FACTORIAL'
  | 'NEXTCLOUD'
  | 'QUICKBASE'
  | 'AIMFOX'
  | 'CIN7_CORE'
  | 'DATTO_RMM'
  | 'FIRSTBASE'
  | 'JAMF_PRO'
  | 'NEXTHINK'
  | 'PEOPLE_DATA_LABS'
  | 'RAPIDAPI'
  | 'TRIPLETEX'
  | 'DEMODESK'
  | 'JAMIE'
  | 'MAXIMIZER'
  | 'PINGONE'
  | 'REDO'
  | 'STREAK'
  | 'VIDEOASK'
  | 'AUVIK'
  | 'CLICKHOUSE'
  | 'DOCUMENT360'
  | 'JOBADDER'
  | 'MEILISEARCH'
  | 'POSTSCRIPT'
  | 'ROCKETLANE'
  | 'SWOOGO'
  | 'WIZA'
  | 'LINEAR'
  | 'TWITCH'
  | 'WHATNOT'
  | 'WIX'
  | 'NMI'
  | 'ORB'
  | 'PYLON'
  | 'TRELLO'
  | 'REPAY'
  | 'SANITY'
  | 'SHIPBOB'
  | 'SHIPHERO'
  | 'SHOPLINE'
  | 'SQUARE'
  | 'SOLIDGATE'
  | 'CLOUDSIGNAL'
  | 'CLOUDINARY'
  | 'COURIER'
  | 'TELNYX'
  | 'CLICKPOST'
  | 'REBILLY'
  | 'HONEYCOMB'
  | 'SONIOX'
  | 'DIGITAL_SAMBA'
  | 'ARGO_CD'
  | 'CONNECTEAM'
  | 'ARCADIA'
  | 'GOVUK_NOTIFY'
  | 'MEASUREONE'
  | 'MONO'
  | 'SWAN'
  | 'PAYRIX_PRO'
  | 'HARBOR'
  | 'VELLUM'
  | 'ESTUARY'
  | 'PROMETHEUS_ALERTMANAGER'
  | 'HUNDRED_MS'
  | 'NAVATTIC'
  | 'GUMLET'
  | 'GC_NOTIFY'
  | 'PAYJP'
  | 'TABBY'
  | 'PAYROC'
  | 'TRENDYOL'
  | 'PLUNK'
  | 'SMTP2GO'
  | 'CLICKATELL'
  | 'KIBANA'
  | 'REBRANDLY'
  | 'PARTICLE'
  | 'AURORA_SOLAR'
  | 'PALMETTO_FINANCE'
  | 'SHIP24'
  | 'ZOOP'
  | 'CELCOIN'
  | 'LEONARDO_AI'
  | 'SEVALLA'
  | 'SUBLIME_SECURITY'
  | 'FIRSTPROMOTER'
  | 'MIGHTY_NETWORKS'
  | 'HOSTAWAY'
  | 'INCODE'
  | 'DATACAKE'
  | 'VENTRATA'
  | 'DISCORD'
  | 'TOKENIO'
  | 'FISERV'
  | 'EMPORIX'
  | 'COVER_GENIUS'
  | 'HONEYBADGER'
  | 'MIDDESK'
  | 'ONCEHUB'
  | 'SALESLOFT'
  | 'TRIGGER_DEV'
  | 'ASSEMBLYAI'
  | 'FOURSQUARE'
  | 'CARTESIA'
  | 'INCREASE'
  | 'MISTRAL'
  | 'OUTREACH'
  | 'SAVVYCAL'
  | 'STIGG'
  | 'UNIT'
  | 'WORKABLE'
  | 'LOKALISE'
  | 'CONFLUENCE'
  | 'PAYSAFE'
  | 'SENDBIRD'
  | 'STORYBLOK'
  | 'WAVE'
  | 'TRUEWORK'
  | 'DOCUMENSO'
  | 'MOONPAY'
  | 'POSTHOG'
  | 'SHOPWARE'
  | 'STREAM'
  | 'XENDIT'
  | 'MEDUSA'
  | 'NORTHFLANK'
  | 'PRINTIFY'
  | 'SHORTCUT'
  | 'TAWK_TO'
  | 'YOUSIGN'
  | 'COTERIE'
  | 'FOOTPRINT'
  | 'MERCURY'
  | 'RECRUITEE'
  | 'SIGNNOW'
  | 'TODOIST'
  | 'ZOHO_SIGN'
  | 'FUSIONAUTH'
  | 'BONDSMITH'
  | 'VERCEL_LOG_DRAINS'
  | 'VERCEL'
  | 'TEBEX'
  | 'SLACK'
  | 'RAZORPAY'
  | 'BELCO'
  | 'HYPERSWITCH'
  | 'ONRAMPER'
  | 'QONTO'
  | 'ZIINA'
  | 'SPACELIFT'
  | 'LANGFUSE'
  | 'OPTIMIZELY'
  | 'CONVOX'
  | 'REWARDFUL'
  | 'REFERRALHERO'
  | 'FOUNTAIN'
  | 'STORYLANE'
  | 'TERRA_API'
  | 'KATANA'
  | 'OXAPAY'
  | 'RETURNLESS'
  | 'BVNK'
  | 'PULUMI'
  | 'AGORA'
  | 'MAILCOACH'
  | 'CHAMELEON'
  | 'TASKADE'
  | 'COMPLYCUBE'
  | 'API_VIDEO'
  | 'CHECKOUT_PAGE'
  | 'KHIPU'
  | 'ROOTFI'
  | 'COLUMN'
  | 'SONARQUBE'
  | 'BASETEN'
  | 'FLUX_CD'
  | 'ARGYLE'
  | 'MEETGEEK'
  | 'IDENFY'
  | 'THINKIFIC'
  | 'SOCOTRA'
  | 'PROOF'
  | 'CREEM'
  | 'KOMOJU'
  | 'PAYPERCUT'
  | 'TERMINAL49'
  | 'CRYPTOPROCESSING'
  | 'FORGEJO'
  | 'WISTIA'
  | 'CONVEX'
  | 'LEARNUPON'
  | 'SURVEYMETHODS'
  | 'PARTNERO'
  | 'NORTHPASS'
  | 'TEXTURE'
  | 'MAILCHIMP'
  | 'NUVEMSHOP'
  | 'PADDLE'
  | 'PAYPAL'
  | 'PAYSTACK'
  | 'MODEM_PAY'
  | 'BITCULATOR'
  | 'PORTAL'
  | 'TREEZOR'
  | 'PRAXIS'
  | 'CUSTOMERIO'
  | 'EXACT_ONLINE'
  | 'FACEBOOK'
  | 'WHATSAPP'
  | 'ABSORB_LMS'
  | 'APPSTLE'
  | 'FOLK'
  | 'HOLDED'
  | 'NOOKS'
  | 'PLANNING_CENTER'
  | 'SEMBLE'
  | 'ZIGPOLL'
  | 'ATHENAHEALTH'
  | 'BASIN'
  | 'DENTALLY'
  | 'LIVE_TENNIS_API'
  | 'PENNYLANE'
  | 'PRIVE'
  | 'TREMENDOUS'
  | 'AGENTCARD'
  | 'CANNY'
  | 'FULLENRICH'
  | 'HUMAANS'
  | 'MAILTRAP'
  | 'TEAMWORK'
  | 'AGENTLINE'
  | 'AUTOSANA'
  | 'CERTN'
  | 'ENVOY'
  | 'GLEAN'
  | 'HUNTRESS'
  | 'TEXTUS'
  | 'VIMEO'
  | 'ANARLOG'
  | 'AUTOTASK'
  | 'CIRCLEBACK'
  | 'HAIL'
  | 'JAZZHR'
  | 'MISSIVE'
  | 'PIPELINE_CRM'
  | 'ROAM'
  | 'THEIRSTACK'
  | 'AUTUMN'
  | 'COMPANYCAM'
  | 'FIBER_AI'
  | 'HITPAY'
  | 'JOBBER'
  | 'MONEYBIRD'
  | 'PLAIN'
  | 'ROCKETREACH'
  | 'THREADS'
  | 'ZENEFITS'
  | 'TIKKIE'
  | 'TIKTOK'
  | 'TIKTOK_SHOP'
  | 'AIRWALLEX'
  | 'ZENDESK'
  | 'UPOLLO'
  | 'BIGCOMMERCE'
  | 'CHARGEBEE_BILLING'
  | 'CHAINDOTS'
  | 'OPENAI'
  | 'DELIVEREASY'
  | 'LOYALTYLION'
  | 'PAYT'
  | 'SEMAPHORE'
  | 'UPLOADCARE'
  | 'OH_DEAR'
  | 'LETTERMINT'
  | 'BUTTONDOWN'
  | 'OPNFORM'
  | 'QLIK_CLOUD'
  | 'REDITUS'
  | 'TUTORCRUNCHER'
  | 'HINT_HEALTH'
  | 'HIGH_MOBILITY'
  | 'DELIVERECT'
  | 'MEMBERFUL'
  | 'PAYTABS'
  | 'TREET'
  | 'FELLOH'
  | 'PLANETSCALE'
  | 'PLANE'
  | 'AGENTSET'
  | 'XTREMEPUSH'
  | 'BUMP_SH'
  | 'AYRSHARE'
  | 'MORTA'
  | 'SENDX'
  | 'DOJAH'
  | 'TEACHFLOOR'
  | 'SPIKE_API'
  | 'TOP_GG'
  | 'FREEMIUS'
  | 'MEWS_POS'
  | 'VIOLET'
  | 'LOGTO'
  | 'HACKERONE'
  | 'CLOUDSMITH'
  | 'KOLIDE'
  | 'ZITADEL'
  | 'TOKITY'
  | 'BIGMAILER'
  | 'FORMSPREE'
  | 'LEARNHOUSE'
  | 'SAHHA'
  | 'HIFI'
  | 'PRECZN'
  | 'RYFT'
  | 'AUTHGEAR'
  | 'FINGERPRINT'
  | 'GITBOOK'
  | 'DUB'
  | 'UPPROMOTE'
  | 'THOUGHT_INDUSTRIES'
  | 'SURVICATE'
  | 'MEDPLUM'
  | 'VIVENU'
  | 'ROOT_PLATFORM'
  | 'GOVUK_PAY'
  | 'POLAR'
  | 'SMILE'
  | 'NYLAS'
  | 'CLIO'
  | 'GOCARDLESS'
  | 'GOOGLE_PUBSUB'
  | 'LINKEDIN'
  | 'LITHIC'
  | 'STRAVA'
  | 'QUO'
  | 'QUOTER'
  | 'OKTA'
  | 'RING_CENTRAL'
  | 'UTILA'
  | 'WECHAT'
  | 'BIRD'
  | 'PROPELAUTH'
  | 'MAILERLITE'
  | 'GO1'
  | 'TERRAFORM'
  | 'BLAND_AI'
  | 'DOPPLER'
  | 'GITEA'
  | 'LOOP_RETURNS'
  | 'CODAT'
  | 'SENDCLOUD'
  | 'TOGGL'
  | 'BOLDSIGN'
  | 'EXPO'
  | 'HEYGEN'
  | 'LUMA'
  | 'STEDI'
  | 'ACUITY_SCHEDULING'
  | 'SMARTSHEET'
  | 'VGS'
  | 'BREEZY_HR'
  | 'FIRECRAWL'
  | 'JFROG'
  | 'CLOUDTALK'
  | 'EXA'
  | 'WAHA'
  | 'MAUTIC'
  | 'YAPILY'
  | 'CENSUS'
  | 'FIREHYDRANT'
  | 'KOMBO'
  | 'GRANOLA'
  | 'HELP_SCOUT'
  | 'CHECK_HQ'
  | 'SEATABLE'
  | 'ABLY'
  | 'CHECKLY'
  | 'FLAGSMITH'
  | 'KUSTOMER'
  | 'KIT'
  | 'DUFFEL'
  | 'TAIGA'
  | 'DESCOPE'
  | 'FOURTHWALL'
  | 'LAGO'
  | 'MONDAY'
  | 'ZEROHASH'
  | 'ZIFT'
  | 'ETHOCA'
  | 'AIRTABLE'
  | 'FASTSPRING'
  | 'FLEXPORT'
  | 'SMARTCAR'
  | 'PAYPRO_GLOBAL'
  | 'USPS'
  | 'CIRCLE'
  | 'UBER'
  | 'FIREFLIES'
  | 'NEON'
  | 'AFFONSO'
  | 'ARDOQ'
  | 'BAMBOOHR'
  | 'BOX'
  | 'BREAKCOLD'
  | 'BUGSMASH'
  | 'CAMPFIRE'
  | 'CASHFREE'
  | 'CHARITYSTACK'
  | 'CHATIM'
  | 'CHILI_PIPER'
  | 'COASSEMBLE'
  | 'CONFIGCAT'
  | 'CYERA'
  | 'FEATUREBASE'
  | 'GREENSHADES'
  | 'HUME'
  | 'INFINITE_GIVING'
  | 'LOB'
  | 'LODGIX'
  | 'MAGIC_HOUR'
  | 'METRONOME'
  | 'MICETRIBE'
  | 'ONSHAPE'
  | 'OPENROUTER'
  | 'PAYNOW_GG'
  | 'PODIUM'
  | 'PURCHASELY'
  | 'QUICKNODE'
  | 'REMOTE_COM'
  | 'SCHEMATIC'
  | 'SENT_DM'
  | 'SINCH'
  | 'SPHEREPAY'
  | 'SPREE'
  | 'TIDIO'
  | 'TILTIFY'
  | 'TWENTY'
  | 'TYPEFULLY'
  | 'ULTRAVOX'
  | 'UPLOAD_POST'
  | 'USESEND'
  | 'VITABLE_HEALTH'
  | 'WHOOP'
  | 'GREENDOT'
  | 'SCRAPFLY'
  | 'PAYMOB'
  | 'WALMART'
  | 'GEMINI'
  | 'REVOLUT'
  | 'CLAUDE'
  | 'ELEVENLABS'
  | 'GEMINI'
  | 'DECK'
  | 'RETELL'
  | 'SHIPSTATION'
  | 'BUNNY_STREAM'
  | 'STATSIG'
  | 'VAPI'
  | 'VOLUME'
  | 'CRONOFY'
  | 'FORMSTACK'
  | 'AFTERSHIP'
  | 'AUTH0'
  | 'BETTER_STACK'
  | 'BITBUCKET'
  | 'CALENDLY'
  | 'CHECKOUT_COM'
  | 'CIRCLECI'
  | 'CLERK'
  | 'DEEPGRAM'
  | 'DOCKER_HUB'
  | 'NEEDLE'
  | 'ACT_ON'
  | 'UKG_READY'
  | 'AMPERSAND'
  | 'EGNYTE'
  | 'BEEHIIV'
  | 'YOUMAIL'
  | 'INGENIOUS_BUILD'
  | 'SIMPRO'
  | 'SAFEBASE'
  | 'KNOWBE4'
  | 'TANIUM'
  | 'SAP_SUCCESSFACTORS'
  | 'TIMIFY'
  | 'WEBINARJAM'
  | 'EMARSYS'
  | 'LUMOS'
  | 'GRAFANA'
  | 'HUGGING_FACE'
  | 'JIRA'
  | 'KLAVIYO'
  | 'KNOCK'
  | 'ONFIDO'
  | 'DWOLLA'
  | 'DIDIT'
  | 'PUSHER'
  | 'LAUNCHDARKLY'
  | 'VERIFF'
  | 'ZERNIO'
  | 'MONGODB_ATLAS'
  | 'TAILSCALE'
  | 'HEROKU'
  | 'MAXIO'
  | 'RUTTER'
  | 'BOLT'
  | 'SIGNAL_SCIENCES'
  | 'MAINTAINX'
  | 'CALLRAIL'
  | 'LEMON_SQUEEZY'
  | 'MODERN_TREASURY'
  | 'CASTLE'
  | 'HIBOB'
  | 'MOTIVE'
  | 'DBT_CLOUD'
  | 'FIVETRAN'
  | 'WEBEX'
  | 'RAMP'
  | 'BUILDKITE'
  | 'DROPBOX'
  | 'STYTCH'
  | 'DAYTONA'
  | 'GOPUFF'
  | 'WHOP'
  | 'CLOUDFLARE'
  | 'MARKETO'
  | 'NINJAONE'
  | 'MAILJET'
  | 'GRAVITY_FORMS'
  | 'ZOOMINFO'
  | 'UNIPILE'
  | 'MAILPARSER'
  | 'HELIUS'
  | 'DATABRICKS'
  | 'APPSFLYER'
  | 'ASAAS'
  | 'OPENCLAW'
  | 'MICROSOFT_DYNAMICS'
  | 'DRATA'
  | 'MOLLIE'
  | 'NOTION'
  | 'ORDINAL'
  | 'POLYTOMIC'
  | 'PAGERDUTY'
  | 'SNIPCART'
  | 'SPARKPOST'
  | 'SUPABASE'
  | 'WEBFLOW'
  | 'REVENUECAT'
  | 'PIPEDREAM'
  | 'TELEGRAM'
  | 'RECALL_AI'
  | 'FATHOM'
  | 'PLEO'
  | 'BROWSERBASE'
  | 'YOCO'
  | 'NASH'
  | 'VANTA'
  | 'GUESTY'
  | 'ADA_SUPPORT'
  | 'AGENTMAIL'
  | 'CRUSOE'
  | 'LOOP'
  | 'OPENMETER'
  | 'SENDOSO'
  | 'SOVOS'
  | 'STITCH_MONEY'
  | 'TASKRABBIT'
  | 'UPHOLD'
  | 'WETRAVEL'
  | 'NANGO'
  | 'SEGMENT'
  | 'N8N'
  | 'ZAPIER'
  | 'AZURE_LOGIC_APPS'
  | 'BREVO'
  | 'GORGIAS'
  | 'GREEN_API'
  | 'FRESHDESK'
  | 'FILLOUT'
  | 'INSTANTLY'
  | 'DEALHUB'
  | 'RUBRIK'
  | 'GOOGLE_WORKSPACE'
  | 'WORDPRESS_COM'
  | 'PAPERGAMES';

export type SourceGenericAuthTypes = 'HMAC' | 'BASIC_AUTH' | 'API_KEY' | 'STANDARD_WEBHOOKS';
export type SourceAuthProvider = SourceGenericAuthTypes | Exclude<SourceType, 'HTTP' | 'WEBHOOK'>;

export type TypeFeatureField = {
  label: string;
  name: string;
  type: 'text' | 'select' | 'password' | 'number' | 'textarea' | 'checkbox' | 'list' | 'object';
  customSchema?: (schema: any) => any;
  /** Longer helper copy rendered by the dashboard next to the field (e.g. checkbox tooltips). */
  description?: string;
  placeholder?: string;
  required?: boolean;
  allow_empty?: boolean;
  features?: IntegrationFeature[];
  options?: { value: string; label: string }[];
};
export type TypeFeatureFields = TypeFeatureField[];

export type SourceTypeFeatureTypes =
  | IntegrationFeature
  | 'CUSTOM_HTTP_METHOD'
  | 'CUSTOM_RESPONSE'
  | 'MANAGED_TOKEN'
  | 'PUBLISH_API'
  | 'TRIM_PAYLOAD';

type SourceTypeManagedCustomResponse = {
  managed: true;
  show_in_guided_connection?: boolean;
  default_value: SourceAllowedHTTPMethod[];
};

type SourceTypeFeatureTypesManaged = SourceTypeManagedCustomResponse;

export type SourceTypeFeatureTypesUnmanaged = {
  managed?: false;
  show_in_guided_connection?: boolean;
  required?: boolean;
  advanced?: boolean;
  // Seeds the initial CUSTOM_HTTP_METHOD selection without pinning it the way
  // `managed` does: the dashboard pre-checks these methods when the type is chosen
  // and the user stays free to change them. Never re-applied on update.
  default_value?: SourceAllowedHTTPMethod[];
  fields?: TypeFeatureFields;
  // Auth methods the type offers, keyed by the provider that verifies them —
  // the value stored as the source's `auth_type` and as its integration
  // provider. Keys are `SourceAuthProvider` rather than
  // `SourceGenericAuthTypes` so a type can name a method after itself (GitLab's
  // `X-Gitlab-Token` method is `GITLAB`).
  auth?: Partial<{
    [key in SourceAuthProvider]: {
      label: string;
      features: IntegrationFeature[];
      fields: TypeFeatureFields;
    };
  }>;
  // The method the dashboard pre-selects when auth is enabled and the source
  // does not name one yet. Types that leave it unset make the user choose.
  default_auth_type?: SourceAuthProvider;
  // Lets a stored `config.auth` name no method: the API accepts it as long as
  // it carries a field some method requires, and drops the other methods'
  // fields when one is named. Set it on types that offered verification before
  // they offered a choice of method, whose existing sources record no
  // `auth_type`. Types that always had the choice leave it unset, so a config
  // naming no method stays invalid for them.
  accepts_config_without_auth_type?: boolean;
};
export type SourceTypeFeature = SourceTypeFeatureTypesManaged | SourceTypeFeatureTypesUnmanaged;
// Callers must establish that the feature exists first: a type that does not
// declare a feature has no managed-ness to test, and letting `undefined`
// through here narrowed it to a declared feature that then threw on access.
export function isSourceTypeFeatureUnmanaged(
  feature: SourceTypeFeature
): feature is SourceTypeFeatureTypesUnmanaged {
  return feature.managed !== true;
}
type FeatureOptions = SourceTypeFeatureTypesManaged | SourceTypeFeatureTypesUnmanaged;

export type SourceTypeFeatures = Partial<{
  [K in SourceTypeFeatureTypes]: FeatureOptions;
}>;

export interface SourceTypeSchema {
  label: string;
  category: 'platform' | 'http';
  description?: string;
  hidden?: boolean;
  popular?: boolean;
  icon?: string;
  features: SourceTypeFeatures;
  configuration_alert?: string;
  configuration_link?: string;
  configuration_link_text?: string;
  external_docs_url?: string;
  icon_domain?: string;
}

export type DestinationType = 'HTTP' | 'CLI' | 'MOCK_API';

export type DestinationTypeFeatureTypes =
  | 'CUSTOM_URL'
  | 'VERIFICATION'
  | 'CUSTOM_DESTINATION_HTTP_METHOD'
  | 'CUSTOM_CLI_PATH'
  | 'MAX_DELIVERY_RATE'
  | 'PATH_FORWARDING';

type GENERIC_AUTH_TYPES =
  | 'HOOKDECK_SIGNATURE'
  | 'CUSTOM_SIGNATURE'
  | 'BASIC_AUTH'
  | 'API_KEY'
  | 'BEARER_TOKEN'
  | 'OAUTH2_CLIENT_CREDENTIALS'
  | 'OAUTH2_AUTHORIZATION_CODE'
  | 'AWS_SIGNATURE'
  | 'GCP_SERVICE_ACCOUNT'
  | 'STANDARD_WEBHOOKS';

export type DestinationTypeFeatureTypesManaged = {
  managed: true;
  default_value: string;
};

export type DestinationTypeFeatureTypesUnmanaged = {
  managed?: false;
  required?: boolean;
  advanced?: boolean;
  delivery_groups?: boolean;
  default_value?: string;
  fields?: TypeFeatureFields;
  auth?: {
    [key in GENERIC_AUTH_TYPES]: {
      label: string;
      fields: TypeFeatureFields;
    };
  };
};
export type DestinationTypeFeature =
  | DestinationTypeFeatureTypesManaged
  | DestinationTypeFeatureTypesUnmanaged;

export const isDestinationTypeFeatureUnmanaged = (
  feature: { managed?: boolean } | undefined
): feature is DestinationTypeFeatureTypesUnmanaged => feature?.managed !== true;

export type DestinationTypeFeatures = Partial<{
  [key in DestinationTypeFeatureTypes]: DestinationTypeFeature;
}>;
export interface DestinationTypeSchema {
  label: string;
  category: 'aws' | 'generic';
  description?: string;
  icon?: string;
  features: DestinationTypeFeatures;
  configuration_alert?: string;
}

export const basic_auth_integration_providers = [
  'BASIC_AUTH',
  'SAP_SUCCESSFACTORS',
  'EMARSYS',
  'CHARGEBEE_BILLING',
  'MAILJET',
  'DATABRICKS',
  'POSTMARK',
  'PIPEDRIVE',
  'KOBOTOOLBOX',
  'THREE_SIXTY_DIALOG',
  'DATOCMS',
  'PARCELLAB',
  'ZUORA',
  'AWS_EVENTBRIDGE',
  'PROXYCLICK',
  'BRAZE',
  'JUMPCLOUD',
  'RUDDERSTACK',
  'SOCURE',
  'FOURKITES',
  'NEW_RELIC',
  'WORKATO',
  'FORMIO',
  'WORKSPACE_ONE',
  'AZURE_DEVOPS',
  'GREENDOT',
  'METABASE',
  'HALO_PSA',
  'ROCKETLANE',
  'DEEPGRAM',
  'REBILLY',
  'KIBANA',
  'CELCOIN',
  'HOSTAWAY',
  'SPARKPOST',
  'AZURE_LOGIC_APPS',
  'BREVO',
];

export interface HMACIntegrationConfigs {
  webhook_secret_key: string;
  algorithm: HMACAlgorithms;
  header_key: string;
  encoding: 'base64' | 'base64url' | 'hex';
  input_encoding?: 'utf8' | 'ascii';
  delimiter: '.' | ':';
  prefix_data_with_timestamp: boolean;
  /**
   * Alias-only (never user-configurable, never set on the generic HMAC source, which is also
   * verified at the edge): the signed string built from the raw body and other request headers,
   * e.g. '{header:x-tito-timestamp}.{body}'. Placeholders: {body} (exactly once),
   * {header:<name>} and {timestamp} (the t=/ts= value inside the signature header). When set,
   * prefix_data_with_timestamp and delimiter are ignored.
   */
  signed_content_template?: string;
}

export interface HandledHMACConfigs extends Pick<HMACIntegrationConfigs, 'webhook_secret_key'> {}

export interface BasicAuthIntegrationConfigs {
  username: string;
  password: string;
}

export interface APIKeyIntegrationConfigs {
  header_key: string;
  api_key: string;
  // Set by a type's alias: the fixed auth scheme the sender puts before the secret
  // (e.g. 'Bearer '), so the user can store just the secret.
  value_prefix?: string;
}

export interface Crc32IntegrationConfigs {
  webhook_id: string;
}

export interface EbayIntegrationConfigs {
  client_id: string;
  client_secret: string;
  dev_id: string;
  verification_token: string;
  environment: string;
}

export interface FiservIntegrationConfigs {
  webhook_secret_key: string;
  store_name: string;
}

/**
 * Configs for integrations that verify an inbound webhook by comparing the API key
 * sent in the request header against this stored key. The platform (sender) includes
 * the key in the webhook; Hookdeck checks it matches.
 *
 * Use this when the platform authenticates *to us* via a static key in a header.
 * @see APIKeyIntegrationConfigs for when the header key name is also configurable.
 */
export interface HandledAPIKeyIntegrationConfigs extends Pick<APIKeyIntegrationConfigs, 'api_key'> {
  api_key: string;
}

export interface PublicKeyIntegrationConfigs {
  public_key: string;
}

/**
 * Configs for Volume (volumepay.io) webhook verification. The RSA public key used to
 * verify signatures is fetched from Volume's environment-specific well-known PEM
 * endpoint, so the only configuration needed is which environment the source targets.
 */
export interface VolumeIntegrationConfigs {
  environment: 'PRODUCTION' | 'SANDBOX';
}

/**
 * Configs for integrations where Hookdeck must call back to a third-party API to complete
 * verification (e.g. fetching a public key or certificate). The api_key here is a credential
 * for Hookdeck's *outbound* request to the platform, not a secret compared against an
 * inbound webhook header.
 *
 * Use this when the platform requires us to authenticate *to them* to retrieve verification material.
 * @see HandledAPIKeyIntegrationConfigs for the inverse pattern (platform authenticates to us).
 */
export interface ThirdPartyAPIKeyConfigs {
  api_key: string;
}

export interface ShopifyIntegrationConfigs
  extends Pick<HMACIntegrationConfigs, 'webhook_secret_key'> {
  rate_limit_period?: 'minute' | 'second';
  rate_limit?: number;
  api_key?: string;
  api_secret?: string;
  shop?: string;
}

export interface VercelLogDrainsIntegrationConfigs {
  webhook_secret_key?: string;
  vercel_log_drains_secret?: string;
}

export interface StandardWebhooksIntegrationConfigs {
  webhook_secret_key: string;
  headers_prefix: string;
}

/**
 * Facts about the request being verified that aren't part of the signed content,
 * passed to verification controllers that need them.
 */
export interface VerificationRequestContext {
  /** When Hookdeck received the request. Stable across re-verification on retry. */
  received_at: Date;
  is_large_payload?: boolean;
}

export interface TiktokShopIntegrationConfigs {
  webhook_secret_key: string;
  app_key: string;
}

export interface ManagedTokenIntegrationConfigs {
  token: string;
}

/**
 * Configs for Google Pub/Sub push subscriptions authenticated with a Google-signed
 * OIDC token. Both values are set on the subscription itself: the audience Google
 * stamps into `aud`, and the service account it impersonates (surfaced as the token's
 * `email` claim). There is no shared secret — the signing keys are Google's public JWKS.
 */
export interface GooglePubSubIntegrationConfigs {
  audience: string;
  service_account_email: string;
}

export type HMACAlgorithms = 'md5' | 'sha1' | 'sha256' | 'sha512';

export type IntegrationConfig =
  | APIKeyIntegrationConfigs
  | EbayIntegrationConfigs
  | HandledAPIKeyIntegrationConfigs
  | HandledHMACConfigs
  | HMACIntegrationConfigs
  | StandardWebhooksIntegrationConfigs
  | APIKeyIntegrationConfigs
  | BasicAuthIntegrationConfigs
  | ShopifyIntegrationConfigs
  | PublicKeyIntegrationConfigs
  | ThirdPartyAPIKeyConfigs
  | VolumeIntegrationConfigs
  | VercelLogDrainsIntegrationConfigs
  | Crc32IntegrationConfigs
  | GooglePubSubIntegrationConfigs
  | ManagedTokenIntegrationConfigs;

export type IntegrationFeature = 'VERIFICATION' | 'HANDSHAKE';

export interface Integration {
  id: string;
  team_id: string;
  label: string;
  provider: SourceAuthProvider;
  features: IntegrationFeature[];
  configs: IntegrationConfig;
  sources: Source[];
  updated_at: string;
  created_at: string;
}

export interface IntegrationCreateInput {
  label: string;
  team_id: string;
  configs: object;
  provider: SourceAuthProvider;
  features: IntegrationFeature[];
  encrypted_configs?: string;
  iv?: string;
}

export interface IntegrationUpdateInput {
  label?: string;
  team_id?: string;
  configs: object;
  features?: IntegrationFeature[];
  encrypted_configs?: string;
  iv?: string;
}
